import { FC } from 'react';
import { ApplicationUser } from '@/types/application-user';
import { AccountButton } from './account-button';
import { AccountDropdown } from './account-dropdown';
import { NotificationBell } from './notification-bell';

export type HeaderProps = {
  user: ApplicationUser;
  onSignOutClick?: () => void;
};

export const Header: FC<HeaderProps> = ({ user, onSignOutClick }) => (
  <header className="flex min-h-16 flex-row justify-end border-b border-gray-200 bg-white px-7 drop-shadow-sm">
    <div className="flex flex-row items-center">
      <NotificationBell />
      <div className="mx-6 h-6 w-px bg-gray-900/10"></div>
      <div className="flex flex-row items-center gap-2">
        {user && (
          <AccountButton firstName={user.firstName} lastName={user.lastName} />
        )}
        <AccountDropdown onSignOutClick={onSignOutClick} />
      </div>
    </div>
  </header>
);
